import React from 'react';

const HideIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <path
        fill='currentColor'
        d='M13.642 19.844l-1.984 1.983-2.436 2.436c-.39.391-1.024.391-1.414 0-.39-.39-.39-1.023 0-1.414l1.833-1.833c-2.36-1.171-4.321-2.997-5.583-5.305-.077-.141-.077-.307 0-.448C6.34 11.083 10.916 8.485 16 8.485c1.829 0 3.593.337 5.207.962l2.156-2.154c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-1.656 1.657-2.547 2.548-.002-.001-1.702 1.703-5.23 5.23zm11.157-8.33c1.276 1.029 2.349 2.292 3.143 3.748.077.14.077.307 0 .447-2.283 4.18-6.859 6.776-11.941 6.776-.689 0-1.368-.047-2.033-.14l2.014-2.014H16c2.978 0 5.4-2.174 5.4-4.846 0-.181-.011-.36-.033-.537l3.432-3.434zM16 10.639c-2.978 0-5.4 2.174-5.4 4.846 0 1.231.514 2.356 1.36 3.212l1.546-1.547c-.32-.476-.506-1.05-.506-1.665 0-.394.076-.77.215-1.116.217.312.578.516.985.516.662 0 1.2-.538 1.2-1.2 0-.407-.204-.767-.515-.985.344-.138.72-.215 1.115-.215.616 0 1.188.187 1.665.506l1.457-1.458c-.882-.563-1.96-.894-3.122-.894z'
      />
    </svg>
  );
};

export default HideIcon;
